var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-line',{attrs:{"chart-options":_vm.options,"chart-data":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }